'use client';

import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { useTranslations } from 'next-intl';
import { GlowTextBody, GlowTitle } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';

const MAX_CUSTOMER_GROUPS_CHOICES = 25;

type CustomerGroupListProps = {
    orderedCustomerGroups: string[];
    selectedCustomerGroups: string[];
    setSelectedCustomerGroups: Dispatch<SetStateAction<string[]>>;
};

export const CustomerGroupList: Component<CustomerGroupListProps> = ({
    orderedCustomerGroups,
    selectedCustomerGroups,
    setSelectedCustomerGroups,
}) => {
    const t = useTranslations('Preview.shopInTheFuture');

    if (orderedCustomerGroups.length === 0) {
        return null;
    }

    const onChangeInputValue = (event: ChangeEvent<HTMLInputElement>) => {
        if (selectedCustomerGroups.includes(event.target.value)) {
            setSelectedCustomerGroups(selectedCustomerGroups.filter((group) => group !== event.target.value));
        } else if (selectedCustomerGroups.length < MAX_CUSTOMER_GROUPS_CHOICES) {
            setSelectedCustomerGroups((prev) => [...prev, event.target.value]);
        }
    };

    return (
        <div className={'flex flex-col gap-0.25'}>
            <fieldset className={'pl-0.5 rounded-0.5 border-medium border-solid border-background-silver'}>
                <GlowTitle fontSize={'title4'} text={t('label.customerGroups')} TagName={'legend'} />
                <div className={'h-[10rem] overflow-y-auto flex flex-col gap-0.5 pl-0.5 pr-1.5'}>
                    {orderedCustomerGroups.map((customerGroup) => (
                        <label className={'flex flex-row gap-0.5'} key={customerGroup}>
                            <input
                                type={'checkbox'}
                                id={customerGroup}
                                name={customerGroup}
                                checked={selectedCustomerGroups.includes(customerGroup)}
                                onChange={onChangeInputValue}
                                value={customerGroup}
                                disabled={
                                    selectedCustomerGroups.length >= MAX_CUSTOMER_GROUPS_CHOICES &&
                                    !selectedCustomerGroups.includes(customerGroup)
                                }
                            />
                            <GlowTextBody text={customerGroup} />
                        </label>
                    ))}
                </div>
            </fieldset>
            <GlowTextBody
                className={'flex justify-end'}
                text={`${selectedCustomerGroups.length}/${MAX_CUSTOMER_GROUPS_CHOICES}`}
            />
        </div>
    );
};
